// Create a custom script to modify the sticky add to cart button
document.addEventListener('DOMContentLoaded', function() {
  // Function to modify the product-quick-add component
  function modifyQuickAddButton() {
    // Find the product-quick-add element that contains the sticky add to cart button
    const quickAddElement = document.querySelector('product-quick-add');
    
    if (quickAddElement) {
      // Find the buy-buttons inside the quick-add element
      const buyButtons = quickAddElement.querySelectorAll('buy-buttons');
      const buttonElements = quickAddElement.querySelectorAll('button[type="submit"]');
      
      if (buttonElements.length > 0) {
        // For each button found, modify its behavior
        buttonElements.forEach(button => {
          // Remove the submit type to prevent form submission
          button.removeAttribute('type');
          
          // Get translated text from data attribute or use fallback
          const translatedText = document.documentElement.getAttribute('data-sticky-buy-now-text') || 'Buy Now';
          button.textContent = translatedText;
          
          // Add click event listener to scroll to product title (H1)
          button.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            
            // Find the product title H1 element
            const productTitle = document.querySelector('h1.product-info__title');
            
            if (productTitle) {
              // Get the position of the product title
              const productTitlePosition = productTitle.getBoundingClientRect().top + window.pageYOffset;
              
              // Add a small offset to position it better in the viewport (adjust as needed)
              const scrollOffset = 100;
              
              // Smooth scroll to the product title
              window.scrollTo({
                top: productTitlePosition - scrollOffset,
                behavior: 'smooth'
              });
            } else {
              // Fallback to scrolling to product-info if H1 not found
              const productInfo = document.querySelector('.product-info');
              if (productInfo) {
                const productInfoPosition = productInfo.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                  top: productInfoPosition - 100,
                  behavior: 'smooth'
                });
              }
            }
            
            return false;
          });
        });
      }
      
      // Disconnect form and prevent default behavior
      if (buyButtons.length > 0) {
        buyButtons.forEach(buyButton => {
          // Remove form attribute to disconnect from product form
          buyButton.removeAttribute('form');
        });
      }
    }
  }
  
  // Initial modification
  modifyQuickAddButton();
  
  // Also set up a mutation observer to handle dynamic content loading
  const observer = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        // Check if our target element has been added to the DOM
        if (document.querySelector('product-quick-add')) {
          modifyQuickAddButton();
        }
      }
    }
  });
  
  // Start observing the document body for changes
  observer.observe(document.body, { childList: true, subtree: true });
});